<!--首页 金额统计图标-->
<template>
    <div ref="siteMoneyEcharts" style="width:95%;height:95%;" class="center" />
</template>

<script>
import { mapState } from "vuex";
var echarts = require("echarts");
export default {
    data() {
        return {
            siteSummaryDatas: null,
            axisData: [],
            moneyData: [],
            powerData: [],
            order_count: [],
            chart: null,
        };
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                if (!val) {
                    this.$emit("search");
                    return;
                }
                this.siteSummaryDatas = JSON.parse(JSON.stringify(val));
                this.axisData = [];
                this.moneyData = [];
                this.powerData = [];
                this.order_count = [];
                this.dealMonthData(this.siteSummaryDatas);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["theme", "siteOrderSummary"]),
    },
    mounted() {
        this.chart = echarts.init(this.$refs.siteMoneyEcharts);
    },
    props: {},
    methods: {
        dataEcharts() {
            this.chart.setOption({
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                toolbox: {
                    right: "8%",
                    feature: {
                        magicType: { show: true, type: ["line", "bar"] },
                        restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                legend: {
                    data: ["金额", "电量", "订单数"],
                },
                dataZoom: [
                    {
                        type: "inside", // 内置于坐标系中
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        moveOnMouseMove: true,
                        preventDefaultMouseMove: true,
                    },
                    {
                        type: "slider",
                        show: true,
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        backgroundColor: "rgba(155,155,155,0)",
                        borderColor: "#f5f3f6",
                        height: 16,
                        bottom: "2%",
                    },
                ],
                xAxis: [
                    {
                        type: "category",
                        data: this.axisData,
                        axisLabel: {
                            margin: 34,
                            textStyle: {
                                color: "clack",
                                align: "center",
                                fontSize: "12",
                                verticalAlign: "middle",
                                lineHeight: 20,
                            },
                            // formatter: function(params) {
                            //     var newParamsName = "";
                            //     var paramsNameNumber = params.length;
                            //     var provideNumber = 5;
                            //     var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            //     if (paramsNameNumber > provideNumber) {
                            //         for (var p = 0; p < rowNumber; p++) {
                            //             var tempStr = "";
                            //             var start = p * provideNumber;
                            //             var end = start + provideNumber - 1;
                            //             if (p == rowNumber - 1) {
                            //                 tempStr = params.substring(start, paramsNameNumber);
                            //             } else {
                            //                 tempStr = params.substring(start, end) + "\n";
                            //             }
                            //             newParamsName += tempStr;
                            //         }
                            //     } else {
                            //         newParamsName = params;
                            //     }
                            //     return newParamsName;
                            // },
                        },
                        axisTick: {
                            interval: 0,
                            length: 5,
                            //  alignWithLabel: true
                        },
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "金额",
                        min: 0,
                        // interval: 3500,
                        axisLabel: {
                            formatter: "{value} 元",
                            textStyle: {
                                fontSize: "12",
                                color: "black",
                            },
                        },
                        splitLine: {
                            //去掉坐标轴的水平虚线指示线
                            show: true,
                        },
                    },
                    {
                        type: "value",
                        name: "电量",
                        min: 0,
                        // interval: 3500,
                        axisLabel: {
                            formatter: "{value} kw·h",
                            textStyle: {
                                fontSize: "12",
                                color: "black",
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "金额",
                        type: "bar",
                        data: this.moneyData,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                    {
                        name: "电量",
                        type: "line",
						smooth: true,
                        yAxisIndex: 1,
                        data: this.powerData,
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                    {
                        name: "订单数",
                        type: "bar",
                        data: this.order_count,
                        // yAxisIndex: 2,
                    },
                ],
            });
        },
        //处理获取到的每个月的数据
        dealMonthData(siteSummary) {
            if (!siteSummary) {
                return;
            }
            for (let i = 0; i < siteSummary.length; i++) {
                let data = JSON.parse(JSON.stringify(siteSummary[i]));
                this.axisData.push(data.name);
                this.moneyData.push(data.money.toFixed(2));
                this.powerData.push(data.power.toFixed(2));
                this.order_count.push(data.order_count);
            }
            this.dataEcharts();
        },
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
